<template>
  <div class="manage">
    <div class="sidebar">
      <span class="header-text">高僑網站後台</span>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-menu-item index="1" @click="toRoute('banner-manager')">
          <i class="el-icon-menu"></i>
          <span slot="title">首頁banner</span>
        </el-menu-item>
        <el-menu-item index="2" @click="toRoute('news-manager')">
          <i class="el-icon-menu"></i>
          <span slot="title">最新消息</span>
        </el-menu-item>
        <el-menu-item index="3" @click="toRoute('rank-manager')">
          <i class="el-icon-menu"></i>
          <span slot="title">榜單</span>
        </el-menu-item>
        <el-menu-item index="4" @click="toRoute('teacher-manager')">
          <i class="el-icon-menu"></i>
          <span slot="title">師資</span>
        </el-menu-item>
        <el-menu-item index="5" @click="toRoute('course-schedule-manager')">
          <i class="el-icon-menu"></i>
          <span slot="title">課程時刻表</span>
        </el-menu-item>
        <el-menu-item @click="showChangePassword">
          <i class="el-icon-menu"></i>
          <span slot="title">更改密碼</span>
        </el-menu-item>
        <el-menu-item @click="logout">
          <i class="el-icon-menu"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>
    <router-view class="manage-content"></router-view>
    <el-dialog
      class="change-password-dialog"
      title="更改密碼"
      :visible="changePasswordDialogVisible"
      @close="changePasswordDialogVisible = false"
      width="600px"
    >
      <el-form
        ref="changePasswordForm"
        :model="changePasswordData"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item label="舊密碼" prop="oldPassword">
          <el-input
            v-model="changePasswordData.oldPassword"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密碼" prop="newPassword">
          <el-input
            v-model="changePasswordData.newPassword"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="確認新密碼" prop="checkPassword">
          <el-input
            v-model="changePasswordData.checkPassword"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changePassword"
            >更改密碼
          </el-button>
          <el-button @click="changePasswordDialogVisible = false"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Api from "@/api/MaganmentApi";

export default {
  data() {
    var validateCheckPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請再次輸入新密碼"));
      } else if (value !== this.changePasswordData.newPassword) {
        callback(new Error("兩次密碼輸入不一樣!"));
      } else {
        callback();
      }
    };
    return {
      changePasswordDialogVisible: false,
      changePasswordData: {
        oldPassword: "",
        newPassword: "",
        checkPassword: ""
      },
      rules: {
        oldPassword: [
          { required: true, message: "請輸入舊密碼", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "請輸入新密碼", trigger: "blur" },
          { min: 5, message: "長度需至少5個字", trigger: "blur" }
        ],
        checkPassword: [{ validator: validateCheckPassword, trigger: "blur" }]
      }
    };
  },
  computed: {
    activeIndex() {
      const routeName = this.$route.name;
      switch (routeName) {
        case "banner-manager":
          return "1";
        case "news-manager":
          return "2";
        case "rank-manager":
          return "3";
        case "teacher-manager":
          return "4";
        case "course-schedule-manager":
          return "5";
        default:
          return "0";
      }
    }
  },
  methods: {
    toRoute(name) {
      if (this.$route.name != name) {
        this.$router.push({ name });
      }
    },
    showChangePassword() {
      this.changePasswordDialogVisible = true;
    },
    logout() {
      localStorage.clear();
      this.$router.push({ name: "login" });
    },
    async changePassword() {
      this.$refs["changePasswordForm"].validate(async valid => {
        if (valid) {
          try {
            await Api.changePassword({
              oldPassword: this.changePasswordData.oldPassword,
              newPassword: this.changePasswordData.newPassword
            });
            this.$message.success("更改密碼成功");
            this.changePasswordDialogVisible = false;
            this.logout();
          } catch (e) {
            this.$message.error(e.response.data.msg);
          }
        } else {
          this.$message.error("密碼資料不正確");
          return false;
        }
      });
    }
  },
  created() {},
  mounted() {},
  components: {}
};
</script>

<style lang="scss">
.manage {
  .el-pagination {
    margin: 20px;
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>

<style lang="scss" scoped>
.manage {
  display: flex;

  .sidebar {
    width: 170px;
    background-color: rgb(84, 92, 100);
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    .header-text {
      font-size: 20px;
      backdrop-filter: blur(5px);
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
      background-color: rgba(0, 0, 0, 0.1);
      color: #fff;
      line-height: 1.46;
      letter-spacing: 2.6px;
      padding: 17px;
    }

    .el-menu {
      border: none;
    }
  }

  .manage-content {
    padding: 20px;
  }

  .change-password-dialog {
    .el-input {
      width: 300px;
    }
  }
}
</style>
